export default function isBodyElement(element: HTMLElement) {
    return element === document.body
}
